/**
 * @author evdokimov
 */
import OldBaseFormMediator from './OldBaseFormMediator'
import StaffOutputReportEditFormConfigController from './edit_config_controller/staffOutput/StaffOutputReportEditFormConfigController'
import _ from 'underscore'
import StaffPerformanceHTMLPreviewGenerator from './preview/html/staffperformance/StaffPerformanceHTMLPreviewGenerator'
import StaffPerformanceCSVPreviewGenerator from './preview/csv/staffperformance/StaffPerformanceCSVPreviewGenerator'
import ATReportParamsStringBuilder from './reportParamsStringBuilder/ATReportParamsStringBuilder'

export default function StaffOutputFormMediator () {}

StaffOutputFormMediator.prototype = _.create(OldBaseFormMediator.prototype)

StaffOutputFormMediator.prototype.init = function ( config ) {
    OldBaseFormMediator.prototype.init.call(this, config);

    return this;
};

StaffOutputFormMediator.prototype.initParamsStringBuilder = function(config) {
    return new ATReportParamsStringBuilder({
            data: {
                users: config.users,
                userGroups: config.userGroups,
                timeZoneGroups: config.timeZoneGroups,
                cpList: config.cpList,
                manageableUserIds: ATReportsStore.getManageableUserIds(),
                projectsWithMaIds: ATReportsStore.getProjectsWithMaIds(),
            },
            reportAuthorizationInfo: ATReportsStore.getReportAuthorizationInfo(),
        })
}

StaffOutputFormMediator.prototype.initEditConfigController = function ( config ) {
    return new StaffOutputReportEditFormConfigController().init(
            {
                panelId: "mainContainer",
                reportAuthorizationInfo: config.reportAuthorizationInfo,
                reportParameters: config.reportParameters,
                users: config.users,
                manageableUsersIds: config.manageableUserIds,
                userGroups: config.userGroups,
                timeZoneGroups: config.timeZoneGroups,
                cpList: config.cpList,
                customersWithMaIds: config.customersWithMaIds,
                projectsWithMaIds: config.projectsWithMaIds,
                changeCallback: () => this.changeParametersCallback(),
            } );
};

StaffOutputFormMediator.prototype.initCsvGenerator = function(){
    return new StaffPerformanceCSVPreviewGenerator().init();
};

StaffOutputFormMediator.prototype.initHtmlGenerator = function(){
    return new StaffPerformanceHTMLPreviewGenerator().init();
};


// WEBPACK FOOTER //
// ./web/js/reports/StaffOutputFormMediator.js